import React from "react";

const Missing = () => {
  return <div>Missing</div>;
};

export default Missing;
